import { render, staticRenderFns } from "./offersList.vue?vue&type=template&id=b48e7b62&"
import script from "./offersList.vue?vue&type=script&lang=js&"
export * from "./offersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports